import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import { getEnvVar } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0
  },
  iframe: {
    display: 'block',
    width: '100%',
    minHeight: 'calc(100vh - 64px)',
    border: 0
  }
}));

const DashboardPreview = () => {
  const classes = useStyles();
  const dashboardUrl = getEnvVar('ADM_DASHBOARD_IFRAME_URL');
  const iFrameRef = useRef(null);
  const xToken = useSelector(store => store.user.xToken);
  const selectedTenantId = useSelector(store => store.user.selectedTenant?.tenantId);
  const selectedContextId = useSelector(
    store => store.user.selectedBusinessContext?.businessContextId
  );
  const token = xToken || window.localStorage.getItem('GCM-xToken');
  const tenantId = selectedTenantId ?? window.localStorage.getItem('GCM-tenantId');
  const contextId =
    selectedContextId ?? window.localStorage.getItem('GCM-businessContextId');
  const iframeKey = useMemo(
    () => `${tenantId || 'no-tenant'}-${contextId || 'no-context'}-${token || 'no-token'}`,
    [contextId, tenantId, token]
  );

  const sendMessageToIframe = useCallback(() => {
    if (!iFrameRef.current?.contentWindow || !dashboardUrl) {
      return;
    }

    if (!token || !tenantId || !contextId) {
      return;
    }

    let targetOrigin = '*';
    try {
      targetOrigin = new URL(dashboardUrl).origin;
    } catch (error) {}

    iFrameRef.current.contentWindow.postMessage(
      {
        token,
        tenantId,
        contextId
      },
      targetOrigin
    );
  }, [contextId, dashboardUrl, tenantId, token]);

  useEffect(() => {
    sendMessageToIframe();
  }, [sendMessageToIframe]);

  return (
    <div className={classes.root}>
      <iframe
        key={iframeKey}
        ref={iFrameRef}
        className={classes.iframe}
        src={dashboardUrl}
        onLoad={sendMessageToIframe}
        title="Dashboard"
      />
    </div>
  );
};

export default DashboardPreview;
